import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/* Fetches a protected photo with the Authorization header (no token in the URL) and renders a blob. */
export const AuthImage = ({ photoId, className = "", alt = "", fallback = null }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    let url;
    setSrc(null);
    setFailed(false);
    api.get(`/photos/${photoId}/file`, { responseType: "blob" })
      .then((r) => { if (!active) return; url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [photoId]);

  if (failed) return fallback || <div className={`${className} bg-[#F1EEE7]`} />;
  if (!src) return <div className={`${className} bg-[#F1EEE7] animate-pulse`} />;
  return <img src={src} alt={alt} className={className} draggable={false} />;
};
